import styled from "styled-components";
import { Container } from "react-bootstrap";

export const FContainer = styled(Container)`
  background-color: ${(props) => (props.dark ? "var(--primary-dark)" : "var(--primary-pght)")};
  margin: auto 0 auto 0 !important;
  color: var(--text-primary-dark);

  img {
    width: 80%;
  }

  h4 {
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
  }

  p {
    margin: 0;
    color: var(--text-primary-dark);
  }

  a {
    text-decoration: var(--text-primary-dark);
  }
`;
